var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-divider d-flex",class:`justify-content-${_vm.alignContent}`},[_c('div',{style:({width: `${_vm.widthLine}%`})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }